import fetch from '@/plugins/fetch'
import queryString from 'query-string'
import jsCookie from 'js-cookie'
import utils from '@/plugins/utils'
import { PREFIX_KS_SORDER } from '@/service'
const api = {
  cmt: `${utils.hostname('cmt')}/v1`,
  explanation: `${utils.hostname('cms')}/publish/998/homeServiceConfig.json`,
  // share: `${utils.hostname('vorder')}/vorder/GetEvaluateInfoAndCommodityInfo`,
  share: `${utils.hostname(
    'forder'
  )}/forder-web/font/GetEvaluateInfoAndCommodityInfo.do`,
  shareKey: `${utils.hostname(
    'activity'
  )}/activity/commercialInterface/getKey.do`,
  recommend: `${utils.hostname('cms')}/publish/998/dingzhi_comment.json`,
  postComment: PREFIX_KS_SORDER + 'comment.do',
  commentFromMember: `${utils.hostname(
    'cmt'
  )}/v1/community/comment/search/object`,
  postCommentToCMT: `${utils.hostname('cmt')}/v1/community/comment`,
  commentFromCMTV2: `${utils.hostname(
    'cmt'
  )}/v2/community/comment/search/object`,
  commentByOrderId: '//cmt.cekid.com/v1/czjyuer/comment/search/community'
}

export default {
  async getTags(store, object_id) {
    try {
      const url = `${api.cmt}/czjyuer/tags`
      const param = queryString.stringify({
        object_id
      })
      const res = await fetch(`${url}?${param}`)
      const json = await res.json()
      if (json.code === 1001) {
        store.commit('setTagList', json.data || [])
      } else {
        return json
      }
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },
  async postComment(store) {
    try {
      const uid = jsCookie.get('uid')
      const skey = jsCookie.get('skey')
      if (uid && skey) {
        // const url = `${api.vorder}/TradeEvaluated`
        const device = utils.getDevice()
        let from = 1
        if (device === 'mobile' || device === 'weixin') {
          from = 2
        } else if (device === 'android') {
          from = 3
        } else if (device === 'ios') {
          from = 4
        }
        const param = JSON.stringify({
          skey,
          // param: JSON.stringify({
          ...{
            uid,
            from,
            source: '2'
          },
          ...store.state.newComment
          // })
        })
        const res = await fetch(api.postComment, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          },
          method: 'POST',
          body: `param=${param}`,
          credentials: 'include'
        })
        const json = await res.json()
        if (json.code === 301021) {
          utils.login()
        } else {
          return json
        }
      } else {
        utils.login()
      }
    } catch (e) {
      throw new Error(e)
    }
  },
  async getCommentDigest({ commit }) {
    try {
      const explanation = await fetch(api.explanation)
      const explanationJson = await explanation.json()
      if (explanationJson) {
        commit('setCommentDigest', explanationJson.data.commentdigest)
      }
    } catch (e) {
      console.log(e)
    }
  },
  async getShareData(
    { commit },
    { uid, skey, vorder_id, sku_id, entity_id, channel_id, home_worker_uid }
  ) {
    try {
      const query_param = {
        uid,
        skey,
        vorder_id,
        sku_id,
        entity_id,
        channel_id,
        home_worker_uid
      }
      const query = queryString.stringify(query_param)
      const share_res = await fetch(`${api.share}?${query}`)
      const shareJson = await share_res.json()
      if (shareJson.code === '1') {
        commit('setShareComment', shareJson.data)
      }
      return shareJson
    } catch (e) {
      console.log(e)
      throw new Error(e.message)
    }
  },
  async getShareKey({ commit }, { uid, url, sku_name }) {
    try {
      const query_param = {
        jsonobj: JSON.stringify({
          linktype: 13,
          uid,
          commercialname: '孩子王',
          linkcontentid: url,
          accessterminal: 2, // 接入终端
          token: 'YjYphjJdS5RzGiOoQmnApw==',
          linkcontenttitle: sku_name,
          ip: '1.1.1.1',
          utype: 2
        })
      }
      const query = queryString.stringify(query_param)
      const share_res = await fetch(`${api.shareKey}?${query}`)
      const shareJson = await share_res.json()
      if (shareJson.result === 0) {
        commit('setShareKey', shareJson.data)
      }
      return shareJson
    } catch (e) {
      console.log(e)
    }
  },
  async getCommentSettings({ commit }) {
    try {
      const settings = await fetch(api.recommend)
      const settingsJson = await settings.json()
      if (settingsJson) {
        commit('setCommentSettings', settingsJson.data)
      }
    } catch (e) {
      console.log(e)
    }
  },
  // 获取会员评价
  async getMemberEvaluate({ commit }, { uid }) {
    try {
      const query_param = {
        has_image: 0,
        page: 1,
        show_reply: 1,
        show_user: 1,
        object_id: uid,
        show_refer_comment: 0,
        size: 2,
        sort_time: 'desc',
        sort_essence: 1
      }
      const query = queryString.stringify(query_param)
      const comment_res = await fetch(`${api.commentFromMember}?${query}`)
      const commentJson = await comment_res.json()
      // if (commentJson.result === 1001) {
      //     // commit('setShareKey', commentJson.data)
      // }
      return commentJson
    } catch (e) {
      console.log(e)
    }
  },
  async getMemberEvaluateList({ commit }, { uid, page, size }) {
    try {
      const query_param = {
        has_image: 0,
        page,
        show_reply: 1,
        show_user: 1,
        object_id: uid,
        show_refer_comment: 0,
        size,
        sort_time: 'desc'
      }
      const query = queryString.stringify(query_param)
      const comment_res = await fetch(`${api.commentFromMember}?${query}`)
      const commentJson = await comment_res.json()
      return commentJson
    } catch (e) {
      console.log(e)
    }
  },
  async postNewComment(store) {
    try {
      const uid = jsCookie.get('uid')
      const skey = jsCookie.get('skey')
      if (uid && skey) {
        // const data = {
        //     uid, skey, ...store.state.commentObj
        // }
        const param = queryString.stringify({
          uid,
          skey,
          ...store.state.commentObj
        })
        console.log(param)
        const res = await fetch(api.postCommentToCMT, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          },
          method: 'POST',
          body: param,
          credentials: 'include'
        })
        // const res = await fetch(api.postCommentToCMT, data, { method: 'POST' })
        const json = await res.json()
        return json
      } else {
        utils.login()
      }
    } catch (e) {
      console.log(e)
    }
  },
  async getMemberEvaluateByPerson({ commit }, { uid, toUid }) {
    try {
      const query_param = {
        uid,
        has_image: 0,
        page: 1,
        show_reply: 0,
        show_user: 0,
        object_id: toUid,
        show_refer_comment: 0,
        size: 1,
        sort_time: 'desc'
      }
      const query = queryString.stringify(query_param)
      const comment_res = await fetch(`${api.commentFromCMTV2}?${query}`)
      const commentJson = await comment_res.json()
      return commentJson
    } catch (e) {
      console.log(e)
    }
  },
  async getCommentByOrderId({ commit }, { object_id, order_id }) {
    try {
      const query_param = {
        has_image: 0,
        page: 1,
        show_reply: 0,
        show_user: 1,
        object_id,
        show_refer_comment: 0,
        size: 1,
        order_id,
        sort_time: 'desc'
      }
      const query = queryString.stringify(query_param)
      const comment_res = await fetch(`${api.commentByOrderId}?${query}`)
      const commentJson = await comment_res.json()
      return commentJson
    } catch (e) {
      console.log(e)
    }
    // ?object_id=1255570&page=1&show_reply=0&show_user=0&size=20&order_id=3026702886119424
  }
}
